import React from 'react';
import { useTranslation } from '../App';

const Navbar = () => {
  const t = useTranslation();
  return (
    <nav>
      <h4>{t.navbar.title}</h4>
    </nav>
  );
};

export default Navbar;